module.exports = __webpack_public_path__ + "static/donkeyapp-e6319ed932924a72abe9c99dab9d4623.png";